<mat-toolbar *ngIf="userValidation$ | async as userValidation" fxFlex="row" fxLayoutAlign="left center" fxLayoutGap="10px" class="header">
  <button mat-icon-button (click)="leftSideNav.toggle();">
    <mat-icon class="icon-display">menu</mat-icon>
  </button>
  <ng-container *ngIf="currentWindowWidth > 476">
    <img class="empamos-text-logo" src="../../../assets/files/empamos_text_negative.png" alt="image">
    <ng-container *ngIf="this.designName != '' && isOnActiveRoute('editor')">
      <span *ngIf="this.shareOption === 'view'" class="material-symbols-outlined radio-icon">visibility</span>
      <span *ngIf="this.shareOption === 'edit' && !isOnActiveRoute('original')" class="material-symbols-outlined radio-icon">edit_square</span>
      <span class="design-name">{{ this.designName }}</span>
    </ng-container>
  </ng-container>
  <span class="spacer"></span>
  <em-recommendation-request emDragCursor [userValidation$]="userValidation$" [shareOption]="this.shareOption"></em-recommendation-request>
  <div class="mini_spacer"></div>
  <em-help-menu [userValidation$]="userValidation$" [shareOption]="this.shareOption"></em-help-menu>
  <div class="mini_spacer"></div>
  <em-extended-options [userValidation$]="userValidation$" [shareOption]="this.shareOption"></em-extended-options>
</mat-toolbar>
